import HeaderBase from './components/cells/HeaderBase';
import HeaderText from './components/cells/HeaderText';

export default function HeaderTextCell() {}

HeaderTextCell.prototype.init = function (params) {
    this.eGui = HeaderBase(HeaderText(params), params);
    return;
};

HeaderTextCell.prototype.getGui = function () {
    return this.eGui;
};
